import styled from 'styled-components';
import { color, space, layout, typography } from 'styled-system';

import theme, { colors } from '@styles/theme';

export const InputLabel = styled('label')(
  {
    color: colors.grayscale.black,
    display: 'block',
    marginBottom: 1,
    ...theme.textStyles.caption,
    width: '100%',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  },
  color,
  space,
  layout,
  typography
);

InputLabel.displayName = 'InputLabel';

export default InputLabel;
